var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15.9946 10 16.9484 9.60491 17.6517 8.90165C18.3549 8.19839 18.75 7.24456 18.75 6.25C18.75 5.25544 18.3549 4.30161 17.6517 3.59835C16.9484 2.89509 15.9946 2.5 15 2.5C14.0054 2.5 13.0516 2.89509 12.3483 3.59835C11.6451 4.30161 11.25 5.25544 11.25 6.25C11.25 7.24456 11.6451 8.19839 12.3483 8.90165C13.0516 9.60491 14.0054 10 15 10ZM15 14.425C12.05 11.6875 8.125 10 3.75 10V23.75C8.125 23.75 12.05 25.4375 15 28.175C17.95 25.4375 21.875 23.75 26.25 23.75V10C21.875 10 17.95 11.6875 15 14.425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLibrary);
export default __webpack_public_path__ + "static/media/mdi_library.f4a1eb8db3ac7133d062b2b08c46be95.svg";
export { ForwardRef as ReactComponent };